import React, { useEffect, useRef, useState } from "react";
import { GET_ALL_GAMES_RESULT } from "../../service/admin.service";
import Navbar from "../../Pages/Navbar/Navbar";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Footer from "../../Pages/Footer/Footer";
import MayaMorning from "../../Charts/PanaCharts/MayaMorning";
import IndraMorning from "../../Charts/PanaCharts/IndraMorning";
import INDRADAY from "../../Charts/PanaCharts/INDRADAY";
import INDRANIGHT from "../../Charts/PanaCharts/INDRANIGHT";
import MAYADAY from "../../Charts/PanaCharts/MAYADAY";
import MAYANIGHT from "../../Charts/PanaCharts/MAYANIGHT";
import { GetAllCharts } from "../../Helpers/GetCharts";
import { common_chart_url } from "../../Config/config";

const Pana_Chart = () => {
  const navigate = useNavigate();
  const { title } = useParams();
  const location = useLocation();
  const [getData, setgetData] = useState([]);
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("0px");
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const handleClick = () => {
    const targetElement = document.getElementById("scroll-down");

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const normalize = (str) =>
    str?.replace(/-/g, "").replace(/\s+/g, "").toUpperCase();

  const normalizedTitle = normalize(title);
  // console.log(normalizedTitle, "normalizedTitle");

  const getResponseData = async () => {
    const req = location.state;

    // const res = await GET_ALL_GAMES_RESULT({ id: req });
    const res = await GetAllCharts(GET_ALL_GAMES_RESULT, req);
    setgetData(res);
  };

  useEffect(() => {
    if (title) getResponseData();
  }, [title]);

  const chartMap = {
    // Maya
    MAYAMORNING: MayaMorning,
    MAYANIGHT: MAYANIGHT,
    MAYADAY: MAYADAY,

    // Indra
    INDRAMORNING: IndraMorning,
    INDRANIGHT: INDRANIGHT,
    INDRADAY: INDRADAY,
  };

  const ChartComponent = chartMap[normalizedTitle];

  const chartUrl = `${common_chart_url}pana-chart/${normalizedTitle}?embed=true&color=%23237f8a`;

  // iframe height listener
  useEffect(() => {
    if (ChartComponent) return;

    const handleMessage = (event) => {
      if (event.data?.type === "SET_HEIGHT") {
        const newHeight = `${event.data.height}px`;
        setIframeHeight(newHeight);
        if (iframeRef.current) {
          iframeRef.current.style.height = newHeight;
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [ChartComponent]);

  return (
    <>
      <div id="scroll-up"></div>
      <Navbar />

      <div className="container-fluid">
        <div className="row">
          <div className="text-center col-xl-12 col-q-12 col-md-12 col-sm-12 chart-header ">
            <div className="pt-110  text-alignment">
              <h2 className="chart-header-font">
                <strong className="color-dark-gray">{normalizedTitle}</strong>
              </h2>
              <p>
                Discover {normalizedTitle} Pana Chart with previous results,
                historical records, and live number updates all available in one
                place.
              </p>
            </div>
            <button
              className="btn-scroll my-3"
              onClick={handleClick}
              id="scroll-down-button"
            >
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                viewBox="0 0 512 512"
                height={20}
                width={20}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M348.3 295.6c-5-5.1-13.3-5.1-18.4-.1L269 356.2V124.9c0-7.1-5.8-12.9-13-12.9s-13 5.8-13 12.9v231.3l-60.9-60.8c-5.1-5-13.3-4.9-18.4.1-5 5.1-5 13.2.1 18.3l83 82.4c1.2 1.1 2.5 2 4.1 2.7 1.6.7 3.3 1 5 1 3.4 0 6.6-1.3 9.1-3.7l83-82.4c5.2-4.9 5.3-13.1.3-18.2z" />
              </svg>
              Go To Bottom
            </button>
          </div>
        </div>
      </div>

      <div className=" ">
        <div className="row justify-content-center">
          <div className="p-0 text-center d-flex justify-content-center   col-xl-12 col-q-12 col-md-12 col-sm-12">
            <div className="table-responsive  text-center col-xl-8 col-lg-12 col-md-12 col-sm-12">
              {ChartComponent ? (
                <ChartComponent chartData={getData.data} />
              ) : (
                <div
                  style={{
                    minHeight: iframeHeight === "0px" ? "200px" : iframeHeight,
                    position: "relative",
                  }}
                >
                  {/* Skeleton Loader */}
                  {isIframeLoading && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        padding: "20px",
                        background: "#fff",
                        zIndex: 10,
                      }}
                    >
                      <div className="skeleton-box"></div>
                      <div className="skeleton-box"></div>
                      <div className="skeleton-box"></div>
                    </div>
                  )}

                  {/* iframe */}
                  <iframe
                    ref={iframeRef}
                    src={chartUrl}
                    title="Charts"
                    onLoad={() => setIsIframeLoading(false)}
                    className="w-100 border-0 transition-all duration-500"
                    scrolling="no"
                    style={{
                      width: "100%",
                      height: iframeHeight,
                      opacity: isIframeLoading ? 0 : 1,
                    }}
                  />
                </div>
              )}

              <div className="row justify-content-start">
                <button
                  className=" btn  rounded-pill back-btn mt-2"
                  onClick={() => navigate(-1)}
                  id="scroll-down-button"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <div id="scroll-down"></div>
    </>
  );
};

export default Pana_Chart;
